import React, { useCallback, useMemo, useState } from "react";
import { AgGridReact, } from 'ag-grid-react'; // React Data Grid Component
import { UuiPagination, UuiSpinner } from "@aonunited/react";
import "./table.scss";
import { formatDate } from "../../../constants/utilities";
var AonAgGridTable = function (props) {
    var _a;
    var _b = useState(null), gridAPi = _b[0], setGridAPi = _b[1];
    var onGridReady = useCallback(function (params) {
        if (params.api) {
            setGridAPi(params.api);
            if (props.setCurrentGridAPI) {
                props.setCurrentGridAPI(params.api);
            }
        }
    }, []);
    var getRowHeight = useCallback(function (params) {
        return 30;
    }, []);
    var Components = useMemo(function () {
        return {
            tooltipComponent: CostomTooltip,
            MarKetNameTooltip: MarKetNameTooltip,
            AdditionalInfoTooltip: AdditionalInfoTooltip,
            AdditionalInfoRatingTooltip: AdditionalInfoRatingTooltip,
            RecentChangesRegionTooltip: RecentChangesRegionTooltip,
        };
    }, []);
    return (
    // Data Grid will fill the size of the parent container
    React.createElement(React.Fragment, null,
        React.createElement("div", { className: "table-ag-grid" },
            React.createElement(AgGridReact, { domLayout: 'autoHeight', getRowStyle: props.rowStyle, rowData: props.rowData, getRowHeight: props.RowHeightCallback || getRowHeight, columnDefs: props.columns, loading: props.loading, pagination: false, 
                //defaultColDef={defaultColDef}
                onGridReady: onGridReady, tooltipShowDelay: 0, tooltipShowMode: "whenTruncated", suppressScrollOnNewData: props.suppressScrollOnNewData, components: Components, loadingOverlayComponent: function () { return React.createElement(UuiSpinner, { variant: "small" }); } })),
        React.createElement("div", { className: "ag-grid-pagination" }, (props.pagination && props.totalCount && props.totalCount > 0 && props.totalCount >= ((_a = props.paginationMinCount) !== null && _a !== void 0 ? _a : 100) && props.rowData.length > 0) ?
            React.createElement("div", { className: "pagination-with-all" },
                !props.isAllSelected &&
                    React.createElement(UuiPagination, { className: "pagination", disabled: props.loading, total: props.totalCount, current: props.currentPage, pageSize: props.pageSize, onChanged: props.onPageChange }),
                props.showAllOption && (props.isAllSelected ?
                    React.createElement("button", { type: "button", className: "pagination-all-button", disabled: props.loading, onClick: props.onPagesClick }, "Pages")
                    :
                        React.createElement("button", { type: "button", className: "pagination-all-button", disabled: props.loading, onClick: props.onAllClick }, "All")))
            : null)));
};
export var CostomTooltip = function (props) {
    return (React.createElement("div", { className: "custom-tooltip", style: { backgroundColor: '#46535e' } },
        React.createElement("div", null, props.value)));
};
export var MarKetNameTooltip = function (props) {
    var rowData = props.data;
    var text = React.createElement("p", null,
        "Name: ",
        props.value,
        " ",
        React.createElement("br", null),
        (rowData === null || rowData === void 0 ? void 0 : rowData.groupName) && "Group Name: ".concat(rowData === null || rowData === void 0 ? void 0 : rowData.groupName));
    return (React.createElement("span", { className: "market-name-tooltip" }, text));
};
export var AdditionalInfoTooltip = function (props) {
    var rowData = props.data;
    var displayFlag = !(rowData === null || rowData === void 0 ? void 0 : rowData.amBestId) && !(rowData === null || rowData === void 0 ? void 0 : rowData.amBestRatingDate) && !(rowData === null || rowData === void 0 ? void 0 : rowData.amBestRatingExplanation) &&
        !(rowData === null || rowData === void 0 ? void 0 : rowData.sAndPId) && !(rowData === null || rowData === void 0 ? void 0 : rowData.sAndpRatingDate) && !(rowData === null || rowData === void 0 ? void 0 : rowData.sAndpRatingExplanation);
    var text = React.createElement("p", null,
        (rowData === null || rowData === void 0 ? void 0 : rowData.amBestId) && "AM Best No: ".concat(rowData === null || rowData === void 0 ? void 0 : rowData.amBestId),
        " ",
        (rowData === null || rowData === void 0 ? void 0 : rowData.amBestId) && React.createElement("br", null),
        (rowData === null || rowData === void 0 ? void 0 : rowData.amBestRatingDate) && "AM Best As Of Date: ".concat(rowData === null || rowData === void 0 ? void 0 : rowData.amBestRatingDate),
        " ",
        (rowData === null || rowData === void 0 ? void 0 : rowData.amBestRatingDate) && React.createElement("br", null),
        (rowData === null || rowData === void 0 ? void 0 : rowData.amBestRatingExplanation) && "AM Best Explanation: ".concat(rowData === null || rowData === void 0 ? void 0 : rowData.amBestRatingExplanation),
        " ",
        (rowData === null || rowData === void 0 ? void 0 : rowData.amBestRatingExplanation) && React.createElement("br", null),
        (rowData === null || rowData === void 0 ? void 0 : rowData.sAndPId) && "S&P ID: ".concat(rowData === null || rowData === void 0 ? void 0 : rowData.sAndPId),
        " ",
        (rowData === null || rowData === void 0 ? void 0 : rowData.sAndPId) && React.createElement("br", null),
        (rowData === null || rowData === void 0 ? void 0 : rowData.sAndpRatingDate) && "S&P As Of Date: ".concat(rowData === null || rowData === void 0 ? void 0 : rowData.sAndpRatingDate),
        " ",
        (rowData === null || rowData === void 0 ? void 0 : rowData.sAndpRatingDate) && React.createElement("br", null),
        (rowData === null || rowData === void 0 ? void 0 : rowData.sAndpRatingExplanation) && "S&P Explanation: ".concat(rowData === null || rowData === void 0 ? void 0 : rowData.sAndpRatingExplanation));
    return (!displayFlag ?
        React.createElement("span", { className: "market-name-tooltip" }, text) : null);
};
export var AdditionalInfoRatingTooltip = function (props) {
    var rowData = props.data;
    var displayFlag = !(rowData === null || rowData === void 0 ? void 0 : rowData.AmBestCode) && !(rowData === null || rowData === void 0 ? void 0 : rowData.AmBestRatingDate) && !(rowData === null || rowData === void 0 ? void 0 : rowData.AmBestRatingExplanation) &&
        !(rowData === null || rowData === void 0 ? void 0 : rowData.SpCode) && !(rowData === null || rowData === void 0 ? void 0 : rowData.SpRatingDate) && !(rowData === null || rowData === void 0 ? void 0 : rowData.SpRatingExplanation);
    var text = React.createElement("p", null,
        (rowData === null || rowData === void 0 ? void 0 : rowData.AmBestCode) && "AM Best No: ".concat(rowData === null || rowData === void 0 ? void 0 : rowData.AmBestCode),
        " ",
        (rowData === null || rowData === void 0 ? void 0 : rowData.AmBestCode) && React.createElement("br", null),
        (rowData === null || rowData === void 0 ? void 0 : rowData.AmBestRatingDate) && "AM Best As Of Date: ".concat(formatDate(rowData === null || rowData === void 0 ? void 0 : rowData.AmBestRatingDate)),
        " ",
        (rowData === null || rowData === void 0 ? void 0 : rowData.AmBestRatingDate) && React.createElement("br", null),
        (rowData === null || rowData === void 0 ? void 0 : rowData.AmBestRatingExplanation) && "AM Best Explanation: ".concat(rowData === null || rowData === void 0 ? void 0 : rowData.AmBestRatingExplanation),
        " ",
        (rowData === null || rowData === void 0 ? void 0 : rowData.AmBestRatingExplanation) && React.createElement("br", null),
        (rowData === null || rowData === void 0 ? void 0 : rowData.SpCode) && "S&P ID: ".concat(rowData === null || rowData === void 0 ? void 0 : rowData.SpCode),
        " ",
        (rowData === null || rowData === void 0 ? void 0 : rowData.SpCode) && React.createElement("br", null),
        (rowData === null || rowData === void 0 ? void 0 : rowData.SpRatingDate) && "S&P As Of Date: ".concat(formatDate(rowData === null || rowData === void 0 ? void 0 : rowData.SpRatingDate)),
        " ",
        (rowData === null || rowData === void 0 ? void 0 : rowData.SpRatingDate) && React.createElement("br", null),
        (rowData === null || rowData === void 0 ? void 0 : rowData.SpRatingExplanation) && "S&P Explanation: ".concat(rowData === null || rowData === void 0 ? void 0 : rowData.SpRatingExplanation));
    return (!displayFlag ?
        React.createElement("span", { className: "market-name-tooltip" }, text) : null);
};
export var RecentChangesRegionTooltip = function (props) {
    var rowData = props.data;
    var displayFlag = !(rowData === null || rowData === void 0 ? void 0 : rowData.region) && !(rowData === null || rowData === void 0 ? void 0 : rowData.marketType) && !(rowData === null || rowData === void 0 ? void 0 : rowData.reinsuranceIndicator) &&
        !(rowData === null || rowData === void 0 ? void 0 : rowData.marketGuideStatus);
    var text = React.createElement("p", null,
        "Region: ", rowData === null || rowData === void 0 ? void 0 :
        rowData.region,
        React.createElement("br", null),
        "Market Type: ", rowData === null || rowData === void 0 ? void 0 :
        rowData.marketType,
        React.createElement("br", null),
        "Reinsurance Indicator: ", rowData === null || rowData === void 0 ? void 0 :
        rowData.reinsuranceIndicator,
        React.createElement("br", null),
        "Status: ", rowData === null || rowData === void 0 ? void 0 :
        rowData.marketGuideStatus,
        React.createElement("br", null));
    return (!displayFlag ?
        React.createElement("span", { className: "market-name-tooltip" }, text) : null);
};
export default AonAgGridTable;
